const numeral = require('numeral');
const moment = require('moment');

module.exports = {
  md5: function (s) {
    // eslint-disable-next-line
    function L(k, d) { return (k << d) | (k >>> (32 - d)) } function K(G, k) { var I, d, F, H, x; F = (G & 2147483648); H = (k & 2147483648); I = (G & 1073741824); d = (k & 1073741824); x = (G & 1073741823) + (k & 1073741823); if (I & d) { return (x ^ 2147483648 ^ F ^ H) } if (I | d) { if (x & 1073741824) { return (x ^ 3221225472 ^ F ^ H) } else { return (x ^ 1073741824 ^ F ^ H) } } else { return (x ^ F ^ H) } } function r(d, F, k) { return (d & F) | ((~d) & k) } function q(d, F, k) { return (d & k) | (F & (~k)) } function p(d, F, k) { return (d ^ F ^ k) } function n(d, F, k) { return (F ^ (d | (~k))) } function u(G, F, aa, Z, k, H, I) { G = K(G, K(K(r(F, aa, Z), k), I)); return K(L(G, H), F) } function f(G, F, aa, Z, k, H, I) { G = K(G, K(K(q(F, aa, Z), k), I)); return K(L(G, H), F) } function D(G, F, aa, Z, k, H, I) { G = K(G, K(K(p(F, aa, Z), k), I)); return K(L(G, H), F) } function t(G, F, aa, Z, k, H, I) { G = K(G, K(K(n(F, aa, Z), k), I)); return K(L(G, H), F) } function e(G) { var Z; var F = G.length; var x = F + 8; var k = (x - (x % 64)) / 64; var I = (k + 1) * 16; var aa = Array(I - 1); var d = 0; var H = 0; while (H < F) { Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = (aa[Z] | (G.charCodeAt(H) << d)); H++ } Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = aa[Z] | (128 << d); aa[I - 2] = F << 3; aa[I - 1] = F >>> 29; return aa } function B(x) { var k = "", F = "", G, d; for (d = 0; d <= 3; d++) { G = (x >>> (d * 8)) & 255; F = "0" + G.toString(16); k = k + F.substr(F.length - 2, 2) } return k } function J(k) { k = k.replace(/rn/g, "n"); var d = ""; for (var F = 0; F < k.length; F++) { var x = k.charCodeAt(F); if (x < 128) { d += String.fromCharCode(x) } else { if ((x > 127) && (x < 2048)) { d += String.fromCharCode((x >> 6) | 192); d += String.fromCharCode((x & 63) | 128) } else { d += String.fromCharCode((x >> 12) | 224); d += String.fromCharCode(((x >> 6) & 63) | 128); d += String.fromCharCode((x & 63) | 128) } } } return d } var C = Array(); var P, h, E, v, g, Y, X, W, V; var S = 7, Q = 12, N = 17, M = 22; var A = 5, z = 9, y = 14, w = 20; var o = 4, m = 11, l = 16, j = 23; var U = 6, T = 10, R = 15, O = 21; s = J(s); C = e(s); Y = 1732584193; X = 4023233417; W = 2562383102; V = 271733878; for (P = 0; P < C.length; P += 16) { h = Y; E = X; v = W; g = V; Y = u(Y, X, W, V, C[P + 0], S, 3614090360); V = u(V, Y, X, W, C[P + 1], Q, 3905402710); W = u(W, V, Y, X, C[P + 2], N, 606105819); X = u(X, W, V, Y, C[P + 3], M, 3250441966); Y = u(Y, X, W, V, C[P + 4], S, 4118548399); V = u(V, Y, X, W, C[P + 5], Q, 1200080426); W = u(W, V, Y, X, C[P + 6], N, 2821735955); X = u(X, W, V, Y, C[P + 7], M, 4249261313); Y = u(Y, X, W, V, C[P + 8], S, 1770035416); V = u(V, Y, X, W, C[P + 9], Q, 2336552879); W = u(W, V, Y, X, C[P + 10], N, 4294925233); X = u(X, W, V, Y, C[P + 11], M, 2304563134); Y = u(Y, X, W, V, C[P + 12], S, 1804603682); V = u(V, Y, X, W, C[P + 13], Q, 4254626195); W = u(W, V, Y, X, C[P + 14], N, 2792965006); X = u(X, W, V, Y, C[P + 15], M, 1236535329); Y = f(Y, X, W, V, C[P + 1], A, 4129170786); V = f(V, Y, X, W, C[P + 6], z, 3225465664); W = f(W, V, Y, X, C[P + 11], y, 643717713); X = f(X, W, V, Y, C[P + 0], w, 3921069994); Y = f(Y, X, W, V, C[P + 5], A, 3593408605); V = f(V, Y, X, W, C[P + 10], z, 38016083); W = f(W, V, Y, X, C[P + 15], y, 3634488961); X = f(X, W, V, Y, C[P + 4], w, 3889429448); Y = f(Y, X, W, V, C[P + 9], A, 568446438); V = f(V, Y, X, W, C[P + 14], z, 3275163606); W = f(W, V, Y, X, C[P + 3], y, 4107603335); X = f(X, W, V, Y, C[P + 8], w, 1163531501); Y = f(Y, X, W, V, C[P + 13], A, 2850285829); V = f(V, Y, X, W, C[P + 2], z, 4243563512); W = f(W, V, Y, X, C[P + 7], y, 1735328473); X = f(X, W, V, Y, C[P + 12], w, 2368359562); Y = D(Y, X, W, V, C[P + 5], o, 4294588738); V = D(V, Y, X, W, C[P + 8], m, 2272392833); W = D(W, V, Y, X, C[P + 11], l, 1839030562); X = D(X, W, V, Y, C[P + 14], j, 4259657740); Y = D(Y, X, W, V, C[P + 1], o, 2763975236); V = D(V, Y, X, W, C[P + 4], m, 1272893353); W = D(W, V, Y, X, C[P + 7], l, 4139469664); X = D(X, W, V, Y, C[P + 10], j, 3200236656); Y = D(Y, X, W, V, C[P + 13], o, 681279174); V = D(V, Y, X, W, C[P + 0], m, 3936430074); W = D(W, V, Y, X, C[P + 3], l, 3572445317); X = D(X, W, V, Y, C[P + 6], j, 76029189); Y = D(Y, X, W, V, C[P + 9], o, 3654602809); V = D(V, Y, X, W, C[P + 12], m, 3873151461); W = D(W, V, Y, X, C[P + 15], l, 530742520); X = D(X, W, V, Y, C[P + 2], j, 3299628645); Y = t(Y, X, W, V, C[P + 0], U, 4096336452); V = t(V, Y, X, W, C[P + 7], T, 1126891415); W = t(W, V, Y, X, C[P + 14], R, 2878612391); X = t(X, W, V, Y, C[P + 5], O, 4237533241); Y = t(Y, X, W, V, C[P + 12], U, 1700485571); V = t(V, Y, X, W, C[P + 3], T, 2399980690); W = t(W, V, Y, X, C[P + 10], R, 4293915773); X = t(X, W, V, Y, C[P + 1], O, 2240044497); Y = t(Y, X, W, V, C[P + 8], U, 1873313359); V = t(V, Y, X, W, C[P + 15], T, 4264355552); W = t(W, V, Y, X, C[P + 6], R, 2734768916); X = t(X, W, V, Y, C[P + 13], O, 1309151649); Y = t(Y, X, W, V, C[P + 4], U, 4149444226); V = t(V, Y, X, W, C[P + 11], T, 3174756917); W = t(W, V, Y, X, C[P + 2], R, 718787259); X = t(X, W, V, Y, C[P + 9], O, 3951481745); Y = K(Y, h); X = K(X, E); W = K(W, v); V = K(V, g) } var i = B(Y) + B(X) + B(W) + B(V); return i.toLowerCase()
  },
  addThousandCommas: function (nStr, overrideFormat) {
    const decimals = /\.0?0?[1-9]{1,3}/;
    const threeDecimal = /\.\d{3}/;

    if(typeof overrideFormat !== 'undefined'){
      return numeral(nStr).format(overrideFormat);
    }

    var defaultFormat = overrideFormat || '0,0';

    if (decimals.test(nStr)) {
      if (threeDecimal.test(nStr)) {
        return numeral(nStr).format('0,0.000')
      }

      return numeral(nStr).format('0,0.00')
    }

    if (parseInt(nStr,10) < 10 ) {
      return numeral(nStr).format(overrideFormat || '0.00')
    }

    return numeral(nStr).format(defaultFormat)
  },
  secondsToTime: function (secs) {
    var one_day = 60 * 60 * 24;    // Convert both dates to milliseconds
    var one_hour = 60 * 60;
    var one_min = 60;

    var returnVal = {
      remainX: 0,
      unit: 'day(s)'
    };

    if (secs >= one_day) {
      returnVal.remainX = Math.round(secs / one_day);
    }
    else if (secs >= one_hour) {
      returnVal.remainX = Math.round(secs / one_hour);
      returnVal.unit = 'hour(s)';
    }
    else if (secs >= one_min) {
      returnVal.remainX = Math.round(secs / one_min);
      returnVal.unit = 'min(s)';
    }
    else {
      returnVal.remainX = Math.floor(secs);
      returnVal.unit = 'seconds';
    }

    return returnVal;
  },
  validateEmail: function validateEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },

  createCookie: function (name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  },
  readCookie: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  eraseCookie: function (name) {
    this.createCookie(name, "", -1);
  },

  daysUntil: function (start, end) {

    var difference_ms = end - start;        // Convert back to days and return

    return difference_ms / 1000;
  },

  isAdmin: function (account) {
    if (account._account_type === 'G') {
      return true;
    } else {
      return false;
    }
  },

  hash: function (loc) {
    if (window.history.pushState) {
      window.history.pushState(null, null, loc);
    }
    else {
      window.location.hash = loc;
    }
  },

  isEmpty: function (str) {
    return (!str || 0 === str.length);
  },

  getparams: function () {
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
      url = window.location.href,
      params = {},
      match;
    while (match === regex.exec(url)) {
      params[match[1]] = match[2];
    }

    return params;
  },

  changeCurrencyFormat: function (price, format = '0,000.00') {
    return '$' + this.addThousandCommas(price, format);
  },

  getCurrency: function (currency="USD") {
    if (currency === 'EUR') {
      return {
        currency: 'EUR',
        currency_symbol: '€',
        currency_selector: 'eur'
      }
    } else if (currency === 'GBP') {
      return {
        currency: 'GBP',
        currency_symbol: '£',
        currency_selector: 'gbp'
      };
    } else if (currency === 'IPO') {
      return {
        currency: 'IPO',
        currency_symbol: '$',
        currency_selector: 'ipo'
      };
    } else if (currency === 'ANG') {
      return {
        currency: 'XCG',
        currency_symbol: 'Cg',
        currency_selector: 'xcg'
      };
    } else if (currency === 'XCG') {
      return {
        currency: 'XCG',
        currency_symbol: 'Cg',
        currency_selector: 'xcg'
      };
    } else {
      return {
        currency: 'USD',
        currency_symbol: '$',
        currency_selector: 'usd'
      };
    }
  },
  /* eslint-disable */
  YEARFRAC: function(start_date, end_date, basis) {
    // Credits: David A. Wheeler [http://www.dwheeler.com/]

    // Initialize parameters
    var basis = (typeof basis === 'undefined') ? 0 : basis;
    var sdate = moment(start_date);
    var edate = moment(end_date);

    // Return error if either date is invalid
    if (!sdate.isValid() || !edate.isValid()) return '#VALUE!';

    // Return error if basis is neither 0, 1, 2, 3, or 4
    if ([0,1,2,3,4].indexOf(basis) === -1) return '#NUM!';

    // Return zero if start_date and end_date are the same
    if (sdate === edate) return 0;

    // Swap dates if start_date is later than end_date
    if (sdate.diff(edate) > 0) {
      var edate = moment(start_date);
      var sdate = moment(end_date);
    }

    // Lookup years, months, and days
    var syear = sdate.year();
    var smonth = sdate.month();
    var sday = sdate.date();
    var eyear = edate.year();
    var emonth = edate.month();
    var eday = edate.date();

    switch (basis) {
      case 0:
        // US (NASD) 30/360
        // Note: if eday == 31, it stays 31 if sday < 30
        if (sday === 31 && eday === 31) {
          sday = 30;
          eday = 30;
        } else if (sday === 31) {
          sday = 30;
        } else if (sday === 30 && eday === 31) {
          eday = 30;
        } else if (smonth === 1 && emonth === 1 && sdate.daysInMonth() === sday && edate.daysInMonth() === eday) {
          sday = 30;
          eday = 30;
        } else if (smonth === 1 && sdate.daysInMonth() === sday) {
          sday = 30;
        }

        return ((eday + (emonth * 30) + (eyear * 360)) - (sday + (smonth * 30) + (syear * 360)));
        break;

      case 1:
        // Actual/actual
        var feb29Between = function(date1, date2) {
          // Requires year2 == (year1 + 1) or year2 == year1
          // Returns TRUE if February 29 is between the two dates (date1 may be February 29), with two possibilities:
          // year1 is a leap year and date1 <= Februay 29 of year1
          // year2 is a leap year and date2 > Februay 29 of year2

          var mar1year1 = moment(new Date(date1.year(), 2, 1));
          if (moment([date1.year()]).isLeapYear() && date1.diff(mar1year1) < 0 && date2.diff(mar1year1) >= 0) {
            return true;
          }
          var mar1year2 = moment(new Date(date2.year(), 2, 1));
          if (moment([date2.year()]).isLeapYear() && date2.diff(mar1year2) >= 0 && date1.diff(mar1year2) < 0) {
            return true;
          }
          return false;
        };
        var ylength = 365;
        if (syear === eyear || ((syear + 1) === eyear) && ((smonth > emonth) || ((smonth === emonth) && (sday >= eday)))) {
          if (syear === eyear && moment([syear]).isLeapYear()) {
            ylength = 366;
          } else if (feb29Between(sdate, edate) || (emonth === 1 && eday === 29)) {
            ylength = 366;
          }
          return edate.diff(sdate, 'days') / ylength;
        } else {
          var years = (eyear - syear) + 1;
          var days = moment(new Date(eyear + 1, 0, 1)).diff(moment(new Date(syear, 0, 1)), 'days');
          var average = days / years;
          return edate.diff(sdate, 'days') / average;
        }
        break;

      case 2:
        // Actual/360
        return edate.diff(sdate, 'days') / 360;
        break;

      case 3:
        // Actual/365
        return edate.diff(sdate, 'days') / 365;
        break;

      case 4:
        // European 30/360
        if (sday === 31) sday = 30;
        if (eday === 31) eday = 30;
        // Remarkably, do NOT change February 28 or February 29 at ALL
        return ((eday + emonth * 30 + eyear * 360) - (sday + smonth * 30 + syear * 360)) / 360;
        break;
    }
  }
  /* eslint-enable */
};
